<template>
  <px-custom-dialog transition="fadet"
                      width="1200"
                      v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <px-resposta-negociacao :resposta="resposta"
                            :dialog="dialog"
                            @negociacao-enviada="onNegociacaoEnviada"/>
  </px-custom-dialog>
</template>
<script>
import RespostaNegociacao from '../RespostaNegociacao.vue';

export default {
  props: {
    resposta: Object,
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    onNegociacaoEnviada() {
      this.emit('negociacao-enviada');
    },
  },
  components: {
    PxRespostaNegociacao: RespostaNegociacao,
  },
};
</script>
